import KunLoading39 from './src/index'

KunLoading39.install = function (Vue) {
	Vue.component(KunLoading39.name, KunLoading39);
}

export default KunLoading39;
